import { AutoCompleteComponent } from '@app/reports/report-settings/auto-complete/auto-complete.component';
import { BarGraphHorizontalComponent } from '@app/reports/graphs/bar-graph-horizontal/bar-graph-horizontal.component';
import { BarGraphStackedComponent } from '@app/reports/graphs/bar-graph-stacked/bar-graph-stacked.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenLineGraphComponent } from '@app/reports/graphs/gen-line-graph/gen-line-graph.component';
import { LineGraphComponent } from '@app/reports/graphs/line-graph/line-graph.component';
import { MarketSegmentsComponent } from '@app/reports/market-segments/market-segments.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaterialDemandComponent } from '@app/reports/material-demand/material-demand.component';
import { NgModule } from '@angular/core';
import { NotificationsModule } from '@app/notifications/shared/notifications.module';
import { PieChartComponent } from '@app/reports/graphs/pie-chart/pie-chart.component';
import { ReportSwitcherComponent } from '@app/reports/report-switcher/report-switcher.component';
import { SalesQuantityComponent } from '@app/reports/sales-quantity/sales-quantity.component';
import { SharedModule } from '@app/shared/shared.module';
import { ShippedOrdersComponent } from '@app/reports/shipped-order/shipped-orders.component';
import { TruckDemandComponent } from '@app/reports/truck-demand/truck-demand.component';
import { WidgetContainerComponent } from '@app/reports/widget-container/widget-container.component';

@NgModule({
  declarations: [
    AutoCompleteComponent,
    BarGraphHorizontalComponent,
    BarGraphStackedComponent,
    GenLineGraphComponent,
    LineGraphComponent,
    MarketSegmentsComponent,
    MaterialDemandComponent,
    PieChartComponent,
    ReportSwitcherComponent,
    SalesQuantityComponent,
    ShippedOrdersComponent,
    TruckDemandComponent,
    WidgetContainerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatOptionModule,
    MatRadioModule,
    MatToolbarModule,
    NotificationsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [WidgetContainerComponent, ReportSwitcherComponent, AutoCompleteComponent],
  providers: []
})
export class ReportsModule {}
